import { render, staticRenderFns } from "./addBackAddress.vue?vue&type=template&id=12765ea8&scoped=true"
import script from "./addBackAddress.vue?vue&type=script&lang=js"
export * from "./addBackAddress.vue?vue&type=script&lang=js"
import style0 from "./addBackAddress.vue?vue&type=style&index=0&id=12765ea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12765ea8",
  null
  
)

export default component.exports